import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { toast } from "react-toastify";
import '../app.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const apiUrl = 'https://jwapi.infosware-test.in/api/login';

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(apiUrl, { username, password });

      if (response.status === 200) {
        toast.success("Login Successful");
        const { token } = response.data; // Extract token from response
        console.log('JWT Token:', token); // Log the token to the console
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('token', token); // Store JWT token
        localStorage.setItem('currentPath', '/items'); // Set default path to /items
        onLogin();
        navigate('/items'); // Redirect to /items page
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('An error occurred. Please try again.');
      }
    }
  };

  return (
    <Container id="login-container">
      <div className='login-form'>
        <h2>Login</h2>
        <Form onSubmit={handleLogin}>
          <Form.Group controlId="username">
            <Form.Label>Username:</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="password">
            <Form.Label>Password:</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button type="submit" variant="primary">
            Login
          </Button>
        </Form>
        {error && <div className="text-danger">{error}</div>}
      </div>
    </Container>
  );
}

export default Login;
